import { BOOSTER_TYPE, ROUTES, SIGNUP_FORM_TYPE } from '../utils/constants/enum'
import searchIcon from '../assets/images/icons/search.svg'

export interface NavItem {
    label: string
    link?: string
    key: string
    type?: string
    icon?: typeof searchIcon
    click_id?: string
}

export interface Nav extends NavItem {
    subMenu?: Array<NavItem>
}

export interface FooterNavType {
    click_id?: string
    heading: string
    navs: Array<NavItem>
}

const HOW_IT_WORKS = {
    label: 'How It Works',
    link: ROUTES.HOW_IT_WORKS,
    key: 'howItWorks',
}

const SKIN_CONDITIONS = {
    label: 'Learn About Skin Concerns',
    link: ROUTES.SKIN_CONDITIONS,
    key: 'aboutSkinTypes',
}
const DOWNLOAD_APP = {
    label: 'Download app',
    link: ROUTES.DOWNLOAD_APP,
    key: 'downloadApp',
}

const TREATMENT_TYPES = {
    label: 'Treatment Types',
    link: ROUTES.TREATMENT_TYPES,
    key: 'treatmentTypes',
}

const FIND_HYDRAFACIALIST = {
    label: 'Find a Hydrafacialist',
    link: ROUTES.FIND_HYDRAFACIALIST,
    key: 'findHydrafacialist',
}

const ABOUT = {
    label: 'About Us',
    link: ROUTES.ABOUT_US,
    key: 'aboutUs',
}

const NEWSROOM = {
    label: 'Newsroom',
    link: ROUTES.NEWSROOM,
    key: 'newsroom',
}

const INVESTOR_RELATIONS = {
    label: 'Investor Relations',
    link: ROUTES.INVESTOR_RELATIONS,
    key: 'investorRelations',
}

const CAREERS = {
    label: 'Careers',
    link: ROUTES.CAREERS,
    key: 'careers',
}

const CLAIMS = {
    label: 'Claims',
    link: ROUTES.CLAIMS,
    key: 'claims',
}

const DEVICES = {
    label: 'Device',
    link: ROUTES.DEVICES,
    key: 'device',
}

const TREATMENTS = {
    label: 'Treatments',
    link: ROUTES.TREATMENTS,
    key: 'treatments',
}

const REWARDS = {
    label: 'Rewards',
    link: ROUTES.REWARDS,
    key: 'rewards',
}

const TRAINING = {
    label: 'Training',
    link: ROUTES.TRAINING,
    key: 'trainig',
}

const STORE = {
    label: 'Store',
    link: `${ROUTES.STORE}`,
    key: 'store',
}

const TALK_WITH_SALES = {
    label: 'Talk With Sales',
    link: ROUTES.TALK_WITH_SALES,
    key: 'talkWIthSales',
}

const TALK_WITH_SALES_BUTTON = {
    label: 'Talk With Sales',
    link: ROUTES.TALK_WITH_SALES,
    key: 'talkWIthSales',
    type: 'button',
}

export const PRIVACY = {
    label: 'Privacy Policy',
    link: ROUTES.PRIVACY,
    key: 'privacyPolicy',
}

export const TERMS_OF_USE = {
    label: 'Terms Of Use',
    link: ROUTES.TERMS_OF_USE,
    key: 'termsOfUse',
}

export const TERMS = {
    label: 'Terms & Conditions',
    link: ROUTES.TERMS,
    key: 'termsAndConditions',
}

const SEARCH = {
    label: 'Search',
    link: ROUTES.SEARCH,
    key: 'search',
    icon: searchIcon,
}

const FOR_PROFESSIONAL = {
    label: 'For Professionals',
    link: ROUTES.FOR_PROFESSIONAL,
    key: 'forProfessional',
}

const FOR_PROFESSIONAL_HOME = {
    label: 'Home',
    link: ROUTES.FOR_PROFESSIONAL,
    key: 'forProfessionalHome',
}

const TREATMENT_TYPE_FACE = {
    label: 'Face',
    link: ROUTES.TREATMENT_TYPE_DETAIL + '/face/',
    key: 'treatmentTypeFace',
}

const TREATMENT_TYPE_BODY = {
    label: 'Body',
    link: ROUTES.TREATMENT_TYPE_DETAIL + '/body/',
    key: 'treatmentTypeBody',
}

const TREATMENT_TYPE_LIPANDEYE = {
    label: 'Lip & Eye',
    link: ROUTES.TREATMENT_TYPE_DETAIL + '/lipAndEye/',
    key: 'treatmentTypeLipAndEye',
}

const TREATMENT_TYPE_SCALP = {
    label: 'Scalp',
    link: ROUTES.TREATMENT_TYPE_DETAIL + '/scalp/',
    key: 'treatmentTypeScalp',
}

const TREATMENT_TYPE_EXPRESS = {
    label: 'Express',
    link: ROUTES.TREATMENT_TYPE_DETAIL + '/express/',
    key: 'treatmentTypeExpress',
}

export const SHOP_HYDRAFACIAL_MERCHANDISE = {
    label: 'Shop Merchandise',
    link: ROUTES.SHOP_MERCHANDISE,
    key: 'ShopHydrafacialMerchandise',
}

export const SHOP_EGIFT_CARDS = {
    label: 'Shop eGift Cards',
    link: ROUTES.SHOP_EGIFT_CARDS,
    key: 'ShopeGiftCards',
}

export const VISIT_HYDRAFACIAL = {
    label: 'Visit hydrafacial.com',
    link: ROUTES.HOME,
    key: 'VisitHydrafacial',
}

export const BOOSTERS = {
    label: 'Boosters',
    link: `/provider-${BOOSTER_TYPE.ENHANCEMENTS}/boosters/`,
    key: 'boosters',
}

export const ACCOUNTS = {
    label: 'Accounts',
    link: ROUTES.SIGNIN,
    key: 'accounts',
}

export const LeftNav: Array<Nav> = []

export const RightNav: Array<Nav> = [SEARCH, FOR_PROFESSIONAL]

export const CareersRightNav: Array<Nav> = [VISIT_HYDRAFACIAL]

export const MobileRightNav: Array<Nav> = []

export const MobileFooterNav: Array<Nav> = []

export const downloadApp: Array<Nav> = [DOWNLOAD_APP]

export const ForProfessionalSubNav: Array<Nav> = [
    FOR_PROFESSIONAL_HOME,
    DEVICES,
    TREATMENTS,
    BOOSTERS,
    REWARDS,
    TRAINING,
    STORE,
    TALK_WITH_SALES_BUTTON,
]

export const HydrafacialSubNav: Array<Nav> = [
    HOW_IT_WORKS,
    TREATMENT_TYPES,
    SKIN_CONDITIONS,
    FIND_HYDRAFACIALIST,
]

export const AboutSubNav: Array<Nav> = [
    ABOUT,
    NEWSROOM,
    INVESTOR_RELATIONS,
    CAREERS,
    CLAIMS,
]

export const TreatmentTypeSubNav: Array<Nav> = [
    TREATMENT_TYPE_FACE,
    TREATMENT_TYPE_BODY,
    TREATMENT_TYPE_LIPANDEYE,
    TREATMENT_TYPE_SCALP,
    TREATMENT_TYPE_EXPRESS,
]

export const FooterNav = {
    colOne: {
        heading: 'HYDRAFACIAL',
        navs: [
            HOW_IT_WORKS,
            TREATMENT_TYPES,
            SKIN_CONDITIONS,
            FIND_HYDRAFACIALIST,
            SHOP_HYDRAFACIAL_MERCHANDISE,
            SHOP_EGIFT_CARDS,
        ],
    },
    colTwo: {
        heading: 'FOR PROFESSIONALS',
        navs: [
            FOR_PROFESSIONAL_HOME,
            DEVICES,
            TREATMENTS,
            BOOSTERS,
            REWARDS,
            TRAINING,
            STORE,
            TALK_WITH_SALES,
            ACCOUNTS,
        ],
    },
    colThree: {
        heading: 'ABOUT US',
        navs: [ABOUT, INVESTOR_RELATIONS, CAREERS, CLAIMS],
    },
}

export const HamburgerNav = {
    colOne: { ...FooterNav.colOne },
    colTwo: { ...FooterNav.colTwo },
    colThree: { ...FooterNav.colThree },
}

// WARN: Please don't change the order of this array
// This defines the way onboarding flow is structured and changing it
// can break the flow.
export const SIGNUP_FORM: Array<string> = [
    SIGNUP_FORM_TYPE.USER,
    // SIGNUP_FORM_TYPE.PHONENUMBER,
    // SIGNUP_FORM_TYPE.EMAIL,
    SIGNUP_FORM_TYPE.OTPVERIFY,
]
